import { FC, useContext } from 'react';
import { Checkbox } from '@chakra-ui/checkbox';
import { BlankSlate, TableContext } from './';
import classnames from 'classnames';
import styles from './TableBody.module.css';
export const TableBody: FC = () => {
  const context = useContext(TableContext);
  const {
    bodyInfo,
    hasBulkSelect,
    getRowId,
    getRowKey,
    rows,
    selectedRows,
    tableName,
    toggleSelectedRow
  } = context;
  if (rows.length === 0) {
    return renderEmptyTable();
  }
  return <tbody data-sentry-component="TableBody" data-sentry-source-file="TableBody.tsx">
      {rows.map(row => {
      /* We currently have a table result set where ids arent in the payload so 
          have a fallback so that we don't live with unsightly console errors  ¯\_(ツ)_/¯
      */
      const rowId = getRowId(row);
      const rowKey = getRowKey(row);
      return <tr key={rowKey}>
            {!!hasBulkSelect && <td className={styles.headerCell}>
                <div className={styles['align-center']}>
                  <Checkbox isChecked={!!selectedRows[rowId]} onChange={() => toggleSelectedRow(row)} />
                </div>
              </td>}
            {bodyInfo.map(col => {
          const className = classnames(styles[`align-${col.cellAlignment}`]);
          return <td className={className} key={`${tableName}-${col.id}-cell-for-row-id-${rowId}`}>
                  {renderCell(col, row, context)}
                </td>;
        })}
          </tr>;
    })}
    </tbody>;
  function renderEmptyTable() {
    return <tbody data-sentry-component="renderEmptyTable" data-sentry-source-file="TableBody.tsx">
        <BlankSlate data-sentry-element="BlankSlate" data-sentry-source-file="TableBody.tsx" />
      </tbody>;
  }
  function renderCell(col, row, context) {
    if (col.renderCell) {
      return col.renderCell(row, context);
    }
    const className = classnames({
      [styles.wrapText]: col.wrapText,
      [styles.noWrapText]: !col.wrapText
    });
    return <span className={className} data-sentry-component="renderCell" data-sentry-source-file="TableBody.tsx">{col.valueFormatter(col.value(row))}</span>;
  }
};